import { useAuthStore } from "@/services/Cognito/authStore";

export const useUserIsSubscribed = () => {
  const stripeSubscriptionValidUntil = useAuthStore(
    (ctx) => ctx.user?.stripeSubscriptionValidUntil,
  );
  if (!stripeSubscriptionValidUntil) return false;
  return stripeSubscriptionValidUntil.getTime() > new Date().getTime();
};
